import React, { forwardRef, Ref } from 'react';
import { InputProps, InputRef } from 'antd';
import { StyledInput } from './InputStyles';

export type IInputProps = InputProps;
export type TInputRef = InputRef;

const Input = ({ prefix, value, ...props }: IInputProps, ref: Ref<InputRef>): JSX.Element => (
  <StyledInput ref={ref} {...props} value={value} prefix={prefix} />
);

export default forwardRef(Input);
